import React from 'react';
import { motion } from 'framer-motion';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-chem-soft/80 px-5 py-14 sm:py-20" data-id="element-39" data-mp="gwx5j3hh17e9">
      <div className="mx-auto max-w-5xl" data-id="element-40" data-mp="vtfk8yos69i4">
        <div className="mx-auto max-w-2xl text-center" data-id="element-41" data-mp="vuh3vrjv44bg">
          <h2 className="font-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-42" data-mp="qt9yu093tj8h">
            🎁 3 bonusy w cenie pakietu
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-43" data-mp="14rrldun9wpot">
            Bez dodatkowych opłat — otrzymasz je od razu po zakupie.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-3" data-id="element-44" data-mp="1ejnl1a50cnv5">
          {bonuses.map((bonus, i) => <motion.article key={bonus.badge} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-chem/20 bg-white p-6 shadow-sm shadow-chem/5" data-id="element-45" data-mp="19k15gu1pivj6" data-mpi={i}>
              <span className="w-fit rounded-md bg-chem px-2.5 py-1 text-[11px] font-bold tracking-wide text-white" data-id="element-46" data-mp="3ttzyrotldijq">
                {bonus.badge}
              </span>
              <h3 className="mt-4 text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-47" data-mp="7li9d18nm402">
                {bonus.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/70" data-id="element-48" data-mp="chz80pdhc0re">{bonus.description}</p>
              <div className="mt-auto pt-5" data-id="element-49" data-mp="gj0wqc9rsuf4">
                <span className="inline-block rounded-full bg-chem/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-chem-deep" data-id="element-50" data-mp="lbu4za4g6kvy">
                  W cenie pakietu
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}